document.addEventListener('DOMContentLoaded', function () {
  function showPrices() {
    const styleTag = document.getElementById('geo-gating-styles');
    if (styleTag) styleTag.remove();

    document.body.classList.add('prices-revealed');
  }

  function checkAndReveal(visitorCountry) {
    if (!visitorCountry) return;
    visitorCountry = visitorCountry.trim().toUpperCase();

    var allowedIsoRaw = document.body.dataset.allowedIso || '';
    var allowedCountries = allowedIsoRaw
      .split(',')
      .map((c) => c.trim())
      .filter(Boolean);

    if (allowedCountries.includes(visitorCountry)) {
      showPrices();
    } else {
      document.body.classList.add('hide-prices');
    }
  }

  function useFallbackDetection() {
    fetch('/browsing_context_suggestions.json')
      .then((res) => res.json())
      .then((data) => {
        if (data?.detected_values?.country?.handle) {
          checkAndReveal(data.detected_values.country.handle);
        }
      })
      .catch((err) => console.warn('Fallback detection failed', err));
  }

  fetch('https://ipapi.co/country/')
    .then((response) => {
      if (response.ok) return response.text();
      throw new Error(response.status);
    })
    .then((country) => checkAndReveal(country))
    .catch((error) => {
      console.warn('ipapi failed, using fallback:', error);
      useFallbackDetection();
    });
});
